import { Injectable, inject } from '@angular/core';
import { ITwoFactorAuthenticationService, TwoFactorAuthenticationDetails } from '@shared/models/two-factor-authentication';
import { Observable } from 'rxjs';
import { IdentityServerDataService } from './identityserver-data.service';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorAuthenticationService implements ITwoFactorAuthenticationService {
  private readonly dataService = inject(IdentityServerDataService);

  public getTwoFactorAuthenticationDetails(): Observable<TwoFactorAuthenticationDetails> {
    return this.dataService.get<TwoFactorAuthenticationDetails>('TwoFactorAuthentication/Details');
  }

  public removeAppBasedTwoFactorAuth(): Observable<void> {
    return this.dataService.delete('TwoFactorAuthentication/AppBased/Remove');
  }
}
